import {createContext} from 'react';
import {MenuContext} from './types/menu';

export const Context = createContext<MenuContext | null>(null);